export function getKeywordsRoutes() {
  return [
    {
      path: "/keywords",
      name: "keywords",
      component: () => import(/* webpackChunkName: keywords-old-backend */ "./components/KeywordsOld.vue"),
    },
  ]
}
